import React from "react"
import {
    InclusionContent,
    ModalBody,
    ModalBodyContent,
    TabsSlider,
    ModalProps,
    Modal,
} from "@silversea-ssc/ui-components-react"
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens"
import BlockContent from "../BlockContent/BlockContent"
import styles from "./InclusionsModal.module.scss"

import InclusionsModalTabContent from "./InclusionsModalTabContent"

interface InclusionsModalProps extends ModalProps {
    selectedStepGroupId: string
    title: string
    inclusionsContentTokens?: TokenValues
    tabs: TabContent[]
}

export type TabContent = {
    id: string
    title: string
    contents: InclusionContent[]
}

const InclusionsModal: React.FC<React.PropsWithChildren<InclusionsModalProps>> = ({
    modal,
    selectedStepGroupId,
    title,
    inclusionsContentTokens,
    tabs,
}) => {
    const selectedIndexTab = tabs.findIndex((c) => c.id == selectedStepGroupId)

    const slides = tabs.reduce<{
        tabs: JSX.Element[]
        slides: JSX.Element[]
    }>(
        (acc, i) => {
            return {
                tabs: [...acc.tabs, <BlockContent key={i.title} value={i.title} />],
                slides: [
                    ...acc.slides,
                    <ModalBodyContent
                        key={i.title}
                        data-content-name="tab_content_overview"
                        className={styles.tabContent}
                    >
                        <div className={styles.contents}>
                            {i.contents.map((c) => {
                                return (
                                    <InclusionsModalTabContent
                                        key={c._id}
                                        tokens={inclusionsContentTokens}
                                        content={c}
                                    />
                                )
                            })}
                        </div>
                    </ModalBodyContent>,
                ],
            }
        },
        {
            tabs: [],
            slides: [],
        },
    )

    return (
        <Modal title={title} modal={modal} size="medium" dataContentName={`modal_inclusions`}>
            <ModalBody variant="full" paddingBottom paddingTop={false}>
                <TabsSlider {...slides} activeSlideIndex={selectedIndexTab} />
            </ModalBody>
        </Modal>
    )
}

export default InclusionsModal
